import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import IconButton from "@mui/material/IconButton";
import { getMembersWithPendingTasksapi } from "src/DAL/Login/Login";
import { CircularProgress } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useChat } from "src/Hooks/ChatContext";
import { _check_chat_existing } from "src/DAL/Chat/Chat";
import { useContentSetting } from "src/Hooks/ContentSettingState";
import CustomMUITable from "src/components/CustomMUITable";
import { useSnackbar } from "notistack";
import { Icon } from "@iconify/react";

const useStyles = makeStyles(() => ({
  loading: {
    marginLeft: "50%",
    marginTop: "20%",
  },
}));

const headers = [
  { label: "Name", key: "name" },
  { label: "Email", key: "email" },
  { label: "Program", key: "program" },
  { label: "Workout %", key: "workout_percentage" },
  { label: "Nutrition %", key: "meal_percentage" },
  { label: "Mindset %", key: "mindset_percentage" },
];

const HarmonyProgram = () => {
  const classes = useStyles();
  const { state } = useLocation();
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const { enqueueSnackbar } = useSnackbar();
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [pageCount, setPageCount] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [dataProgram, setDataProgram] = useState([]);
  const { userInfo } = useContentSetting();
  const params = useParams();
  const { chatList, handleSetSelectedChat, get_chat_list } = useChat();

  const getMemberList = async (search) => {
    setIsLoading(true);
    const result = await getMembersWithPendingTasksapi(
      params.program_id,
      page,
      rowsPerPage,
      search
    );
    if (result.code == 200) {
      setTotalPages(result?.pagination?.total_pages);
      setTotalCount(result?.pagination?.totalMembers);

      let temp = result?.incomplete_members?.map((item, index) => {
        return {
          ...item,
          program: state?.title ? state?.title : "Harmony Program",
          workout_percentage: (item.workout_percentage ?? 0).toFixed(2),
          mindset_percentage: (item.mindset_percentage ?? 0).toFixed(2),
          meal_percentage: (item.meal_percentage ?? 0).toFixed(2),
        };
      });
      setDataProgram(temp);
      setIsLoading(false);
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
      setIsLoading(false);
    }
  };

  const searchFunction = () => {
    setPage(0);
    setPageCount(1);
    getMemberList(searchText);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    if (newPage <= 0) {
      setPageCount(1);
    } else {
      setPageCount(newPage + 1);
    }
  };

  const handleChangePages = (event, newPage) => {
    if (newPage <= 0) {
      setPage(0);
      setPageCount(1);
    } else {
      setPage(newPage - 1);
      setPageCount(newPage);
    }
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChatList = async (value) => {
    let already_exist = chatList.find((chat) =>
      chat?.members.some((user) => user.id == value.member_id)
    );

    if (already_exist) {
      handleSetSelectedChat(already_exist);
    } else {
      const result = await _check_chat_existing(value.member_id);
      let selected_obj = {};
      if (result.code === 200 && !already_exist) {
        let my_profile = {
          name: userInfo.name,
          profileImage: userInfo.image.thumbnail_1,
          unread_message_count: 0,
          isOnline: true,
          id: userInfo._id,
        };
        let receiver_profile = {
          name: result.memberInfo.name,
          profileImage: result.memberInfo.profile_image,
          isOnline: result.memberInfo.is_online,
          unread_message_count: 0,
          id: result.memberInfo.id,
        };
        selected_obj = {
          chatId: result.chatId,
          my_profile,
          receiver_profile,
          members: [my_profile, receiver_profile],
        };
        handleSetSelectedChat(selected_obj);
      }
    }
  };
  const handlePreview = (value) => {
    navigate(
      `/dashboard/harmony-program/${value.member_id}/${params.program_id}`
    );
  };

  const TABLE_HEAD = [
    { id: "action", label: "Action", type: "action" },
    { id: "number", label: "#", type: "number" },
    { id: "name", label: "Name" },
    { id: "email", label: "Email" },
    { id: "workout_percentage", label: "Workout %" },
    { id: "meal_percentage", label: "Nutrition %" },
    { id: "mindset_percentage", label: "Mindset %" },
  ];

  function download_csv_file(csv, csvFileData) {
    const headerRow = csv.map((column) => column.label);
    const csvRows = [headerRow];

    csvFileData.forEach((row) => {
      const dataRow = csv.map((column) => {
        const value =
          row[column.key] !== undefined && row[column.key] !== null
            ? row[column.key]
            : "";
        return `"${value.toString().replace(/"/g, '""')}"`;
      });

      csvRows.push(dataRow);
    });

    const csvContent = csvRows.map((row) => row.join(",")).join("\n");

    const hiddenElement = document.createElement("a");
    hiddenElement.href = "data:text/csv;charset=utf-8," + encodeURI(csvContent);
    hiddenElement.target = "_blank";
    hiddenElement.download = "Non-Compliance Members.csv";
    hiddenElement.click();
  }

  const handleNavigateImportMember = () => {
    download_csv_file(headers, dataProgram);
  };

  useEffect(() => {
    get_chat_list();
  }, []);

  useEffect(() => {
    getMemberList(searchText);
  }, [page, rowsPerPage]);

  const MENU_OPTIONS = [
    {
      label: "Chat",
      icon: "mdi:chat",
      handleClick: handleChatList,
    },
    {
      label: "View Chart",
      icon: "mdi:chart-line",
      handleClick: handlePreview,
    },
  ];

  if (isLoading == true) {
    return <CircularProgress className={classes.loading} color="primary" />;
  }

  return (
    <div className="container">
      <div className="row">
        <div className="col-lg-9 col-sm-12 d-flex align-items-center">
          <IconButton
            className="back-screen-button ms-2"
            onClick={() => {
              navigate(-1);
            }}
          >
            <ArrowBackIcon />
          </IconButton>
          <div>
            <h2>{state?.title ? state?.title : "Harmony Program"}</h2>
            <h3
              style={{
                color: "#F47E20",
              }}
            >
              Non-Compliance Members
            </h3>
            <p>
              The percentages shown under the Workout, Nutrition, and Mindset
              columns represent the member’s completed tasks from the past week.
            </p>
          </div>
        </div>
        <div className="col-lg-3 col-sm-12 text-end ">
          <button
            onClick={handleNavigateImportMember}
            className="small-contained-button"
          >
            Export Csv &nbsp;&nbsp; <Icon icon={"ic:outline-file-download"} />
          </button>
        </div>
        <div className="col-12 mt-4">
          <CustomMUITable
            TABLE_HEAD={TABLE_HEAD}
            data={dataProgram}
            MENU_OPTIONS={MENU_OPTIONS}
            className="card-with-background"
            custom_pagination={{
              total_count: totalCount,
              rows_per_page: rowsPerPage,
              page: page,
              handleChangePage: handleChangePage,
              onRowsPerPageChange: handleChangeRowsPerPage,
            }}
            custom_search={{
              searchText: searchText,
              setSearchText: setSearchText,
              handleSubmit: searchFunction,
            }}
            pageCount={pageCount}
            totalPages={totalPages}
            handleChangePages={handleChangePages}
            pagePagination={true}
            rows_per_page_count={rowsPerPage}
          />
        </div>
      </div>
    </div>
  );
};

export default HarmonyProgram;
